import { FieldPath } from "react-hook-form";
import { EmployeeFormValues } from "./formContext";

export const stepFields: FieldPath<EmployeeFormValues>[][] = [
  ['fname','lname', 'gender', 'dob', 'maritalStatus', 'bloodGroup', 'nationality','profilePhoto'],
  ['officialEmail', 'personalEmail', 'mobileNumber', 'altContact'],
  ['presentAddress', 'permanentAddress', 'city', 'state', 'country', 'pinCode'],
  ['department', 'designation', 'employmentType', 'workMode', 'dateOfJoining', 'confirmationDate', 'manager'],
  ['shiftName', 'attendanceMode', 'biometricId', 'weeklyOffDays'],
  ['ctc', 'paymentMode', 'bankDetails.bankName', 'bankDetails.accountNumber', 'bankDetails.ifsc'],
  ['pan', 'aadhaar'],
  // ['documents.resume', 'documents.panCard.file', 'documents.aadhaarCard.file', 'documents.offerLetter'],
  ['skills','offerLetter', 'certifications', 'experience.totalYears', 'experience.relevantYears', 'laptopSerial', 'vpnInstalled', 'emergencyContact.name', 'emergencyContact.number', 'emergencyContact.relationship']
];
